<template>
  <birthday-layout @on-scroll="handleScroll" :enable-scroll-event="true" id="board-hidden">
    <div>
      <BoardContent
        ref="boardContent"
        class="board-content-offset"
        :is-hidden-messages="true"
        @set-debounce="setDebounce"
      />
    </div>
  </birthday-layout>
</template>

<script>
import BoardContent from '@/components/Board/Main/BoardContent';
import BirthdayLayout from '@/components/BirthdayLayout.vue';

export default {
  data() {
    return {
      debounce: false,
    };
  },
  components: {
    BoardContent,
    BirthdayLayout,
  },
  methods: {
    async handleScroll($event) {
      if (this.debounce) return;
      const scrollElement = await $event.target.getScrollElement();
      if (
        scrollElement.clientHeight + scrollElement.scrollTop >=
        (scrollElement.scrollHeight || scrollElement.clientHeight)
      ) {
        this.debounce = true;
        await this.$refs.boardContent.loadMorePosts();
      }
    },
    setDebounce(value) {
      this.debounce = value;
    },
  },
  ionViewWillEnter() {
    this.$nextTick(() => {
      this.$refs.boardContent?.refreshPosts();
    });
  },
};
</script>

<style scoped>
.board-content-offset {
  padding-top: var(--board-fixed-height, 152px);
}
</style>
